/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Dashboard_Members_Joined_This_MonthInputs */

const en_admin_dashboard_members_joined_this_month = /** @type {(inputs: Admin_Dashboard_Members_Joined_This_MonthInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`member joined this month`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`members joined this month`);
	return /** @type {LocalizedString} */ ("admin.dashboard.members_joined_this_month");
};

const de_admin_dashboard_members_joined_this_month = /** @type {(inputs: Admin_Dashboard_Members_Joined_This_MonthInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("de", i?.count, {});return /** @type {LocalizedString} */ (`Mitglieder sind diesen Monat beigetreten`)
};

const es_admin_dashboard_members_joined_this_month = /** @type {(inputs: Admin_Dashboard_Members_Joined_This_MonthInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("es", i?.count, {});return /** @type {LocalizedString} */ (`miembros se unieron este mes`)
};

const fr_admin_dashboard_members_joined_this_month = /** @type {(inputs: Admin_Dashboard_Members_Joined_This_MonthInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("fr", i?.count, {});return /** @type {LocalizedString} */ (`membres ont rejoint ce mois-ci`)
};

const nl_admin_dashboard_members_joined_this_month = /** @type {(inputs: Admin_Dashboard_Members_Joined_This_MonthInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`lid toegetreden deze maand`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`leden toegetreden deze maand`);
	return /** @type {LocalizedString} */ ("admin.dashboard.members_joined_this_month");
};

const it_admin_dashboard_members_joined_this_month = /** @type {(inputs: Admin_Dashboard_Members_Joined_This_MonthInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("it", i?.count, {});return /** @type {LocalizedString} */ (`membri iscritti questo mese`)
};

const pt_br2_admin_dashboard_members_joined_this_month = /** @type {(inputs: Admin_Dashboard_Members_Joined_This_MonthInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("pt-BR", i?.count, {});return /** @type {LocalizedString} */ (`membros começando este mês`)
};

const pl_admin_dashboard_members_joined_this_month = /** @type {(inputs: Admin_Dashboard_Members_Joined_This_MonthInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("pl", i?.count, {});return /** @type {LocalizedString} */ (`członków dołączyło w tym miesiącu`)
};

const hu_admin_dashboard_members_joined_this_month = /** @type {(inputs: Admin_Dashboard_Members_Joined_This_MonthInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("hu", i?.count, {});return /** @type {LocalizedString} */ (`tag csatlakozott ebben a hónapban`)
};

/** @type {(inputs: Admin_Dashboard_Members_Joined_This_MonthInputs) => LocalizedString} */
const ro_admin_dashboard_members_joined_this_month = en_admin_dashboard_members_joined_this_month;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "member joined this month" |
* | "other" | "members joined this month" |
*
* @param {Admin_Dashboard_Members_Joined_This_MonthInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_members_joined_this_month = /** @type {((inputs: Admin_Dashboard_Members_Joined_This_MonthInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Members_Joined_This_MonthInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_members_joined_this_month(inputs)
	if (locale === "de") return de_admin_dashboard_members_joined_this_month(inputs)
	if (locale === "es") return es_admin_dashboard_members_joined_this_month(inputs)
	if (locale === "fr") return fr_admin_dashboard_members_joined_this_month(inputs)
	if (locale === "nl") return nl_admin_dashboard_members_joined_this_month(inputs)
	if (locale === "it") return it_admin_dashboard_members_joined_this_month(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_members_joined_this_month(inputs)
	if (locale === "pl") return pl_admin_dashboard_members_joined_this_month(inputs)
	if (locale === "hu") return hu_admin_dashboard_members_joined_this_month(inputs)
	return ro_admin_dashboard_members_joined_this_month(inputs)
});
export { admin_dashboard_members_joined_this_month as "admin.dashboard.members_joined_this_month" }